// extracted by mini-css-extract-plugin
export default {"listElement":"ListElement_listElement__rBmsL","alt":"ListElement_alt__mXgdN"};